export default {
  lang: 'Français',
  homeScreen: {
    title: '',
    stayConnected: 'Restez connecté',
    comingSoon: 'Bientôt disponible',
    messages: 'Messages',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    },
    programStatus: {
      title: 'Mon statut',
      loading: 'Chargement…',
      yourRep: 'Ton Rep',
      myProfile: 'Mon profil',
      favorites: 'Favoris',
      registeredOn: 'Inscrit le :',
      graduatedOn: 'Diplômé le :',
      totalBadgesEarned: 'Total des badges obtenus :',
      lastBookingLogged: 'Dernière réservation enregistrée :',
      currentTier: 'Niveau actuel',
      lastBadgeEarned: 'Dernier badge obtenu :',
      currentFocus: 'Objectif actuel :',
      changeProfilePicture: 'Modifier la Photo de Profil',
    },
    todaysfocus: {
      title: 'Objectif du jour',
      empty: "Aucun objectif pour aujourd'hui",
      loading: 'Chargement…',
      error: "Une erreur s'est produite",
      slideNavAria: 'Navigation des diapositives',
      slideAria: 'Diapositive',
      carouselAria: 'Objectif du jour',
    },
    welcome: 'Bienvenue !',
    welcomeBack: 'Bon retour, {firstName} !',
    notifications: {
      loading: 'Chargement…',
      empty: 'Aucune notification',
    },
    achievements: {
      title: 'Récompenses & Concours',
      loading: 'Chargement…',
      lastBooking: 'Dernière soumission',
      currentTier: 'Niveau actuel',
      contestEntries: 'Total des participations',
      nightsBooked: 'Nuits réservées',
      totalRevenue: "Chiffre d'affaires total déclaré",
      noBookingData: 'Aucune donnée de réservation disponible.',
      notAvailable: 'N/D',
      fileUploadSuccess: 'Le fichier a été téléchargé avec succès.',
      quickSubmit: {
        title: 'Soumission rapide',
        uploading: 'Téléchargement…',
        clear: 'Effacer',
        submit: 'Soumettre',
        submitSuccessSimulated: 'Réservation soumise avec succès',
      },
    },
  },
  notification: {
    newAndNow: 'Nouveau & Maintenant!',
    alert: 'Alerte',
    message: 'Message',
    badge: 'Nouveau Badge',
    contest: 'Concours',
    'content-update': 'Mise à jour de contenu',
    events: 'Événements',
    other: 'Notification',
    welcome: 'Bienvenue',
  },
  loginScreen: {
    version2custom: {
      defaultAmbassador: {
        step2: 'Étape 1 : Créer un compte',
        step3: 'Étape 2 : Créer votre profil',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          "Ce programme est actuellement réservé aux employés du secteur de l'hôtellerie et de la restauration basés à Houston.Bien que nous espérions élargir les critères d'éligibilité à l'avenir, veuillez noter que les participants qui ne remplissent pas les conditions requises actuellement risquent d'être exclus du programme.",
      },
      app1857: {
        fields: {
          howDiscoveredKLA: 'Comment avez-vous découvert la Key Lime Academy ?',
          tradeshowDetailLabel: 'Quel salon ou quelle conférence ?',
          tradeshowDetailPlaceholder: 'Veuillez saisir le nom du salon ou de la conférence',
          discoverVisitFloridaKeys: 'Site web Visit Florida Keys',
          discoverSearchEngine: 'Moteur de recherche (par ex. Google, Yahoo)',
          discoverAiTool: 'Outil IA/recherche (par ex. ChatGPT, Perplexity)',
          discoverSocialMedia: 'Réseaux sociaux (par ex. Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'E-mail ou newsletter',
          discoverWordOfMouth: 'Bouche-à-oreille',
          discoverTradeshowConference: "Salon ou conférence (veuillez nous indiquer de quel salon il s'agit)",
          discoverOtherTravproAffiliate: 'Autres sites affiliés à TravPRO',
        },
      },
      app1865: {
        fields: {
          topTravelType: 'Quel est le type de voyage que vous vendez le plus ?',
          travelTypeAdventure: 'Aventure/Aventure Douce/Expédition',
          travelTypeAllInclusive: 'Tout Inclus',
          travelTypeBusinessMice: 'Affaires/MICE',
          travelTypeCultureExperiential: 'Culture/Expérientiel',
          travelTypeCruise: 'Croisière',
          travelTypeFamilyMultiGen: 'Famille/Multigénération',
          travelTypeRomance: 'Romance/Mariage/Lune de miel',
          travelTypeLuxury: 'Luxe',
          travelTypeRail: 'Train',
          travelTypeTours: 'Tours',
          travelTypeWellness: 'Bien-être/Santé/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing:
            "Restez en contact avec l'équipe professionnelle du secteur du voyage et les partenaires de ce programme, et recevez les dernières informations.",
        },
      },
      app842: {
        fields: {
          segments: 'Quel(s) segment(s) vendez-vous principalement ?',
          segmentLeisure: 'Loisirs',
          segmentCorporate: 'Entreprise',
          segmentGroup: 'Groupe',
        },
      },
    },
    version2: {
      homeTitle: 'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Entrez l'adresse e-mail que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        'Aucun compte trouvé ({email}), veuillez essayer avec une autre adresse e-mail ou créer un compte maintenant.',
      continueButton: 'Continuer',
      success: "Compte mis à jour avec succès ! Vous serez redirigé sous peu vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un e-mail de confirmation pour vérifier votre compte.',
      loginButton: 'Se connecter',
      matchFound: 'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink: 'Connectez-vous via un lien dans votre e-mail :',
      magicLinkButton: 'Demander un lien magique',
      magicLinkTitle: 'Recevez un lien direct par e-mail qui vous connectera instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        'Veuillez prendre un moment pour compléter toutes les informations ci-dessous car elles rempliront votre profil personnel et vos informations de contact.',
      titleIndustry:
        'Veuillez prendre un moment pour compléter toutes les informations ci-dessous car elles rempliront votre profil personnel et vos informations de contact.',
      register: 'Créer un compte',
      agent: 'Conseiller voyage',
      visitor: "Visiteur de l'industrie",
      ambassador: 'Ambassadeur',
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        "Êtes-vous sûr de ne pas être intéressé à rester connecté à l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      step2Sub3: 'Parlez-nous de votre employeur',
      privacyHead: 'PRÉFÉRENCES DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de soutien au réseautage et aux ventes commerciales de TravPRO Mobile.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons, n'utilisons mal ou ne trahissons jamais votre confiance.",
      store: "Téléchargez facilement ce programme sur votre boutique d'applications :",
      powered: 'PROPULSÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous avons envoyé votre lien de réinitialisation de mot de passe par e-mail ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting: "L'adresse e-mail que vous avez saisie n'existe pas.",
        magicLinkMessage: 'Veuillez patienter, nous vous connectons maintenant.',
        magicLinkError:
          "Nous n'avons pas pu trouver votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas pu trouver un jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si ce problème persiste, veuillez nous contacter à : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas pu trouver votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess: 'Vérifiez votre e-mail à {email}. Il contient un lien magique qui vous connectera.',
        magicLinkErrorWait: 'Veuillez attendre 5 minutes entre les demandes de lien magique.',
        emailNotFoundError:
          "L'adresse e-mail que vous avez saisie est introuvable dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'Le code postal ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe que vous avez saisis ne correspondent pas',
        passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          'Cette adresse e-mail existe déjà ou est invalide. Veuillez essayer avec une autre adresse e-mail ou vous connecter à votre compte.',
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez saisir votre e-mail.',
        emailNotExisting: "L'adresse e-mail que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy: 'Mot de passe oublié et vous voulez le changer ? ',
        forgotSubCopy2:
          'Vous voulez contourner complètement le mot de passe ? Nous vous enverrons un e-mail avec un lien magique qui vous connectera automatiquement au programme. ',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description: "Qu'est-ce qui décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisir un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: 'Nom de votre agence',
        employer: "Nom de l'entreprise de votre employeur",
        employerRole: 'Quelle description correspond le mieux à votre rôle ?',
        employerYears: "Depuis combien d'années résidez-vous dans la région où vous travaillez ?",
        title: 'Votre rôle (sélectionnez-en un)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate: "Quelle est votre affiliation d'agence PRINCIPALE ?",
        hostAgency: 'Votre agence hôte ?',
        ataCliaArc: 'Quel est votre numéro ATA/CLIA/ARC?',
        executive: 'Cadre',
        management: 'Direction',
        marketing: 'Marketing',
        sales: 'Ventes',
        coordinator: 'Coordinateur',
        other: 'Autre',
        opt: "Restez connecté à l'équipe commerciale de ce programme et recevez les mises à jour.",
        optMarketing: 'Restez connecté à TravPRO concernant des programmes et événements similaires.',
        retail: 'Magasin de détail',
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: 'Agence hôte',
        call: "Centre d'appels ou agence en ligne",
        describes: "Qu'est-ce qui vous décrit le mieux, vous et l'activité de votre agence ? ",
        invalidEmail: 'Veuillez saisir une adresse e-mail valide',
        roleDMO: 'DMO',
        roleEventEmployee: 'Employé événementiel',
        roleHotelEmployee: "Employé d'hôtel",
        roleRestaurantBar: 'Employé de restaurant/bar',
        roleRetailService: 'Employé de commerce et de services',
        roleTourActivity: "Employé d'agence de voyages et d'activités",
        roleTransportation: 'Employé dans les transports',
        roleOther: 'Autre',
        yearsJustArrived: "Je viens d'arriver (< 6 mois)",
        years1to5: '1 à 5 ans',
        years5to10: '5 à 10 ans',
        years10Plus: '10 ans et plus',
      },
    },
    title: "Programme de formation et d'habilitation des ventes pour professionnels du voyage", // Spécifique au produit (texte TravPRO ou ChannelPRO)
    welcome: {
      headerTop: 'Bienvenue dans',
    },
    sellingPoints: {
      // Tous les arguments de vente peuvent être spécifiques au produit
      0: 'Apprenez, promouvez et vendez en déplacement',
      1: 'Formation multimédia sur tous les appareils',
      2: "Certificat d'achèvement",
      3: "Présentations de vente prêtes à l'emploi",
      4: 'Matériel promotionnel à fort impact',
      5: "Conseils d'initiés et promotions",
      6: 'Répertoire de produits en temps réel',
      7: 'Actualités et mises à jour en temps opportun',
    },
    emailPrompt:
      'Veuillez saisir votre adresse e-mail et votre mot de passe pour confirmer que vous êtes un professionnel du voyage.', // Spécifique au produit (texte TravPRO ou ChannelPRO)
    tAndC: {
      agree: 'En continuant, vous acceptez notre ',
      privacyPolicy: 'politique de confidentialité',
      and: ' et nos ',
      termsConditions: 'conditions générales',
    },
    fields: {
      what: 'Quel type de voyage vendez-vous ?',
      what1: 'Quel est le type de voyage n°1 que vous vendez ?',
      what2: 'Quel est le type de voyage n°2 que vous vendez ?',
      what3: 'Quel est le type de voyage n°3 que vous vendez ?',
      agency: 'Agence *',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe *',
      firstName: 'Prénom *',
      lastName: 'Nom de famille *',
      agencyName: "Nom de l'agence *",
      city: 'Ville *',
      stateProvince: 'État / Province *',
      salutation: 'Salutation *',
      required: 'Obligatoire',
      invalidEmail: 'Adresse e-mail invalide',
      complete: 'Étape 2 : Complétez votre profil',
      tell: 'Parlez-nous de vous',
      title: 'Titre professionnel *',
      host: "Nom de l'agence hôte",
      country: 'Pays / Région',
      select: 'Veuillez sélectionner une option ci-dessous',
      header2: 'Quel(s) segment(s) vendez-vous principalement ?',
      step2: 'Décrivez votre entreprise',
      leisure: 'Loisirs',
      corporate: 'Entreprise',
      group: 'Groupe',
      affiliate: 'Quelle est votre affiliation principale ?',
      forgot:
        'Mot de passe oublié ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: 'Merci de votre intérêt pour\n{clientName}', // Spécifique au produit
      messageWeb:
        'Le contenu de ce site est exclusivement destiné aux professionnels du voyage.\nPour en savoir plus sur {clientName}, veuillez visiter : ', // Spécifique au produit
      messageMobile:
        "Une partie du contenu de cette application est exclusivement destinée aux professionnels du voyage, mais n'hésitez pas à parcourir un aperçu de ce que cette application a à offrir en appuyant sur 'Continuer'.", // Spécifique au produit
      continue: 'Continuer',
      visitWebsite: 'Visiter le site web',
    },
    newUser: 'Nouvel utilisateur',
    register: "S'inscrire",
    registered: 'Cet e-mail est déjà enregistré',
    forgot: 'Réinitialiser le mot de passe',
    header:
      "Veuillez prendre un moment pour compléter toutes les informations ci-dessous, car c'est ce qui remplira votre profil et vos informations de contact.",
    step1: 'Étape 1 : Complétez votre adresse e-mail et choisissez un mot de passe.',
  },
  welcomeScreen: {
    helloUser: 'Bonjour {{name}}',
    hello: 'Bonjour,',
    fromAgency: 'de {{agency}}',
    notUser: 'Pas {{name}} ?',
    introOnline:
      "Formez-vous immédiatement en ligne ou préchargez le contenu pour qu'il soit toujours disponible hors ligne !",
    introOffline:
      "Vous avez déjà la dernière version préchargée. Commencez la formation ou la vente à tout moment, n'importe où !",
    startTraining: "Commencer l'apprentissage",
    continueTraining: "Continuer l'apprentissage",
    graduated: 'Félicitations !',
    downloader: {
      preload: 'Précharger',
      stop: 'arrêter',
      init: 'Initialisation...',
      lastUpdate: 'Dernière mise à jour : ',
    },
  },
  trainingScreens: {
    start: 'Commencer',
    continue: 'Continuer',
    review: 'Réviser',
    restart: 'Redémarrer',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% terminé',
    unlock: "Débloquez ce chapitre en terminant le chapitre d'entraînement {number}.",
    unlockFoundation: "Débloquez ce chapitre en terminant le chapitre d'entraînement {number}.",
    unlockSpecialization: 'Déverrouillez en gagnant votre certificat.',
    unlockPartners: 'Déverrouillez en gagnant votre certificat.',
    unlockRetain: 'Débloquez ce chapitre en terminant les fondamentaux dans {name}.',
    unlockSubtitle: "Débloquez plus de chapitres en terminant les chapitres d'entraînement.",
    allUnlocked: 'Vous avez débloqué tous les chapitres !',
    certificate: 'Certificat',
    courseComplete: 'Continuer',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer dans ce chapitre ou appuyez sur le bouton retour pour revenir à l'aperçu.",
    watchListenRead: 'Regarder, écouter et lire plus',
    trouble:
      'Il semble que vous ayez des difficultés, veuillez relire le contenu de la ou des pages précédentes et réessayer.',
    confirm: 'Confirmez votre réponse',
    choose: 'Veuillez choisir une réponse',
    skip: 'Retour >',
    viewAllTitle: 'Conseil de formation',
    viewAll:
      "Pour passer à la page suivante, veuillez vous assurer d'avoir bien pris connaissance de tout le contenu de la page. Cela peut inclure le visionnage de toutes les vidéos, le clic sur les icônes pour afficher les documents supplémentaires et la réponse correcte aux questions. Ces informations utiles vous sont fournies afin d'améliorer votre formation et de vous permettre d'obtenir le statut PRO.",
    fillBlanks: 'Remplissez le(s) blanc(s) :',
    next: 'Question suivante',
    retry: 'Réessayer',
    fastTrackContinue: 'Continuer le Fast Track',
    fastTrackMoveToFull: 'Annuler le Fast Track',
    fastTrackPrompt:
      "Vous considérez-vous déjà comme un expert BVI ? Souhaitez-vous tenter d'obtenir votre certification par voie rapide ? Une tentative, 15 questions, note de passage de 80 % (B) requise.",
    grading: 'Votre note finale est : {grade}',
  },
  nav: {
    home: 'Accueil',
    train: 'Formation',
    learn: 'Apprendre',
    retain: 'Retenir',
    directory: 'Répertoire',
    showRoom: 'Vitrines',
    showcases: 'Vitrines',
    offers: 'Offres',
    promote: 'Promouvoir',
    sell: 'Vendre',
    info: 'Info',
    rewards: 'Récompenses',
    achievements: 'Réalisations',
    media: 'Médias',
    favorites: 'Favoris',
    contact: "Rencontrer l'équipe",
    reportCard: 'Voir le diplôme',
    accountSettings: 'Paramètres du compte',
    changeProfileImage: "Modifier l'image de profil",
    messages: 'Messages',
    search: 'Rechercher',
  },
  contentHeaders: {
    train: 'Formation',
    retain: 'Retenir',
    subapps: ' Modules de microapprentissage partenaires',
    subAppsFull: ' COMPAGNONS DE VENTE PARTENAIRES',
    maintrainings: 'Les fondements',
    subtrainings: "L'expérience",
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: "Éduquez, engagez et devenez l'expert.",
    trainAmbassador: 'Éduquez, engagez et devenez un ambassadeur expert.',
    showroom: '',
    retain:
      "Félicitations pour avoir terminé votre formation ! Vous avez maintenant débloqué votre ressource de référence pour conserver vos connaissances d'expert et faciliter vos efforts de vente. Utilisez cette zone pour répondre expertement à une question sur un produit ou même comme présentation de vente improvisée — à tout moment, n'importe où et depuis n'importe quel appareil.",
    retainAmbassador:
      "Félicitations pour avoir terminé votre formation ! Vous avez maintenant débloqué votre ressource de référence pour conserver vos connaissances d'expert et faciliter vos efforts de vente. Utilisez cette zone pour répondre expertement à une question sur un produit ou même comme présentation de vente improvisée — à tout moment, n'importe où et depuis n'importe quel appareil.",
    promote: "Partagez ces éléments pour susciter l'intérêt et entamer une conversation avec les clients et prospects.",
    promoteAmbassador:
      'Ici, vous trouverez des ressources pour rester à jour sur les essentiels du tourisme, ainsi que des contenus intéressants à partager avec les visiteurs et à les aider à vivre le meilleur de la destination.',
    sell: 'Répondez aux questions des clients et concluez la vente comme un pro avec des ressources approfondies et un support de vente ciblé.',
    favorites: 'Consultez votre contenu personnellement mis en favoris',
    search: 'Parcourez tout le contenu',
    subapps: "Gagnez un badge de spécialiste en complétant ces modules partenaires rapides d'un seul chapitre.",
    subAppsFull: "Atteignez le statut d'expert complet en apprenant à connaître nos partenaires",
    maintrainings: 'Complétez ces modules essentiels pour obtenir votre certificat.',
    subtrainings: 'Améliorez votre jeu et gagnez un badge pour chaque chapitre de spécialisation ci-dessous.',
    fastTrack: 'Vous êtes actuellement dans le Fast Track. Terminez-le pour obtenir votre note !',
  },
  general: {
    chapter: 'Chapitre',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Rechercher',
    logIn: 'Se connecter',
    logOut: 'Se déconnecter',
    viewItem: 'Voir {type}',
    imageNotFound: 'Image non trouvée',
    noResultsFor: 'Aucun résultat trouvé pour {query}',
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore reçu de messages !",
    resultsFor: 'Résultats pour : {{query}}',
    showAll: 'Tout afficher',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page non trouvée !',
    oops: 'Oups...',
    overview: "Retour à l'aperçu",
    complete: 'Continuer',
    courseComplete: 'Chapitre terminé !',
    chapterComplete: 'Chapitre terminé !',
    message: '{count} message',
    messagePlural: '{count} messages',
    viewBadge: 'Voir',
    downloadBadge: 'Télécharger le badge',
    viewBadge2: 'Badge',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Site web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Faites tourner les cadrans pour correspondre à la réponse',
    fitb: 'Remplissez le(s) blanc(s)',
    flip: 'Changez le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisissez la ou les bonnes réponses',
    slider: 'Choisissez la bonne réponse en utilisant le curseur',
    map: 'Répondez à la question en tapant sur le bon endroit sur la carte',
    dropdown: 'Choisir...',
    true: 'Vrai',
    false: 'Faux',
    arrangeTheWords: 'Cliquez sur les mots dans le bon ordre pour compléter la phrase, puis cliquez sur Envoyer:',
    matchTheSentence:
      'Cliquez sur une phrase à gauche, puis sur sa correspondance à droite. Assemblez toutes les paires pour compléter la question.',
  },
  reportCard: {
    download: 'Télécharger',
    email: 'E-mail',
    print: 'Imprimer',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Se désinscrire',
    settings: 'Paramètres de confidentialité',
    message:
      "Vous ne nous avez rien dit sur vos préférences de confidentialité des données ! C'est correct, mais nous aimerions vous offrir la meilleure expérience avec le Compagnon de vente.",
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use: "Le {{appName}} nécessite l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voir comment activer vos cookies {{here}}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour voir ce contenu',
    guest: 'Invité',
  },
  demo: {
    message:
      "Ce site web est une démo du produit final. Il est actuellement en développement et n'est pas un produit complet.",
    consent: 'Compris !',
  },
  share: {
    header: 'Partagez cette ressource sur vos réseaux sociaux préférés !',
    download: 'Télécharger',
    button: 'Partager',
  },
  sharing: {
    copyURL: 'Copier le lien',
    copied: 'Copié',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "Il semble que vous essayiez d'accéder à l'application {appName} depuis un appareil mobile",
    body: "Pour télécharger ce programme, visitez simplement votre boutique d'applications et recherchez {appName} ou cliquez sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'Apprenez, promouvez et vendez en déplacement',
      2: 'Formation multimédia sur tous les appareils',
      3: "Certificat d'achèvement",
      4: "Présentations de vente prêtes à l'emploi",
      5: 'Matériel promotionnel à fort impact',
      6: 'Répertoire de produits en temps réel',
      7: 'Actualités et mises à jour en temps opportun',
    },
  },
  directoryView: {
    accommodations: 'Hébergements',
    dining: 'Restaurants',
    tourOperators: 'Opérateurs de tourisme',
    attractions: 'Attractions',
    cvb: 'Offices de tourisme',
    entertainment: 'Divertissement',
    events: 'Événements',
    food: 'Cuisine',
    hotels: 'Hôtels',
    placesToStay: 'Lieux à séjourner',
    shopping: 'Shopping',
    search: 'Rechercher...',
    amountOfResults: 'Nombre de résultats : ',
    filter: 'Filtrer',
    filters: 'Filtres :',
    subFilter: 'Sous-filtre',
    category: 'Catégorie',
    subcategory: 'Sous-catégorie',
    resetFilters: 'Réinitialiser les filtres',
    showResults: 'Afficher les résultats',
    clear: 'Effacer',
    noResults: 'Aucun résultat trouvé. Veuillez essayer avec une recherche différente.',
    resetMap: 'Réinitialiser la carte au début >',
    viewNow: 'Voir maintenant >',
  },
  directory: {
    artsentertainment: 'Arts et divertissement',
    conventionservices: 'Services de convention',
    divingsnorkeling: 'Plongée et plongée avec tuba',
    film: 'Film',
    hotels: 'Hôtels',
    lgbtgymsandspas: 'LGBT+ : Gymnases et spas',
    lgbtshopping: 'LGBT+ : Shopping',
    lgbtwheretostay: 'LGBT+ : Où séjourner',
    multiculturaldining: 'Multiculturel : Restauration',
    multiculturalnightlife: 'Multiculturel : Vie nocturne',
    nightlife: 'Vie nocturne',
    petfriendly: 'Accueillant pour les animaux',
    restaurants: 'Restaurants',
    shopping: 'Shopping',
    spas: 'Spas',
    sports: 'Sports',
    transportation: 'Transport',
    venues: 'Lieux',
    waterways: 'Voies navigables',
    waystoplay: 'Façons de jouer',
    weddinglocations: 'Lieux de mariage',
    weddingvendors: 'Fournisseurs de mariage',
    attraction: 'Attractions',
    cvb: 'Offices de tourisme',
    accommodation: 'Hébergements',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Je suis un...',
    brandAmbassador: 'Ambassadeur de marque',
    travelPro: 'Professionnel du voyage',
  },
  rewards: {
    rewards: 'Récompenses',
    title: 'Bienvenue au Centre des Récompenses',
    subheader: 'Suivez et Partagez vos Soumissions de Réservations et Récompenses',
    titleAmbassador: 'Bienvenue au Centre des Réalisations',
    subheaderAmbassador:
      'Suivez vos réalisations de formation, échangez vos récompenses et partagez vos certifications.',
    lockedPopupNotGraduated:
      'Bénéficiez de ces avantages réservés aux diplômés en suivant la formation et en obtenant votre certificat ',
    button: 'Soumettre votre réservation',
    products: 'Marché',
    viewAllBookings: 'Réservations',
    viewLeaderboard: 'Classement',
    viewDashboard: 'Tableau de Bord des Points',
    viewRewards: 'Aperçu',
    home: {
      entries: 'Entrées Actuelles',
      trainingAchievements: 'RÉALISATIONS DE FORMATION',
      trainingAchievementsText:
        'Suivez votre progression de formation, vos certifications et le statut de vos récompenses métalliques sur cette page. Vous pourrez également télécharger et partager votre diplôme, ainsi que tous les badges que vous avez obtenus.',
      bookingContests: 'TABLEAU DE BORD DES RÉSERVATIONS',
      bookingContestsText:
        'Suivez et gérez facilement les soumissions de réservations actuelles sur le Tableau de bord des réservations.',
      submitBooking: 'SOUMETTRE DES RÉSERVATIONS',
      submitBookingText:
        "C'est ici que vous soumettrez les réservations pour inclusion dans les concours de réservations.",
      currentContest: 'CONCOURS ACTUEL',
      currentContests: 'CONCOURS ACTUELS',
      contestEnterBookings: 'saisissant vos réservations',
      contestNow: ' maintenant !',
      contestSeeOther: 'Voir autres ',
      contestTerms: 'Termes et Conditions',
      noContest: "Le concours n'est actuellement pas disponible.",
    },
    bookingRewardsView: {
      title: 'Marché',
    },
    bookingsView: {
      title: 'Réservations',
    },
    leaderboardScreen: {
      title: 'CLASSEMENT \n des Points',
      earnedpts: 'MES POINTS GAGNÉS :',
      pointsWall: 'SUIVI DU TOP 5 DES POINTS :',
      startEarning: 'Commencez maintenant à gagner des XP et rejoignez le classement !',
      prizes: 'Prix',
      tAndC: "Les termes et conditions s'appliquent*",
      pointsOverview: {
        title: 'Comment gagner des points',
        booths: "Visiter les Vitrines d'Exposants",
        breakoutSessions: 'Assister aux Sessions de Travail et Mises en Lumière de Destinations',
        trainingSessions: 'Compléter un Chapitre de Formation',
        adventureSpotlights: 'Conseils de Voyage en Famille',
        share: 'Partager du Contenu',
        shareMax: "(jusqu'à {maxSharePoints} points)",
        shareInfo:
          "Le partage est compté en partageant le contenu de stand sur X et Facebook ou en partageant l'ensemble du stand avec des collègues ou des clients.",
        viewVideo: 'Voir la Vidéo',
      },
    },
    dashboardView: {
      title: 'Tableau de Bord des Réservations',
      subtitle: 'Suivez et Gérez vos Inscriptions de Réservation Ici.',
      badge: 'Badges',
      activity: 'Tableau de Bord des Réservations',
      manage: 'Gérer les Réservations',
      manageSub:
        "Triez en utilisant les boutons ci-dessus et cliquez sur n'importe quel enregistrement pour gérer les détails de soumission. Toutes les inscriptions en attente seront vérifiées dans les 72 heures. ",
      noBookings: "Il n'y a aucun enregistrement à afficher.",
      state: {
        approvedEntries: 'Inscriptions Approuvées',
        pendingEntries: 'Inscriptions en Attente',
        declinedEntries: 'Inscriptions Refusées',
        viewAll: 'Voir Tout',
      },
      columns: {
        wholesaler: 'Grossiste',
        clientLastName: 'Nom de famille du client',
        totalCostUsd: 'Coût total USD',
        hotelName: "Nom de l'hôtel",
        hotelConfirmNumber: 'Numéro de confirmation hôtel',
        flightNumber: 'Numéro de vol',
        typeOfBooking: 'Type de réservation',
        checkIn: 'Arrivée',
        checkOut: 'Départ',
        status: 'Statut',
      },
    },
    bookingForm: {
      title: 'Formulaire de Soumission de Réservation',
      subTitle: 'Entrez votre réservation :',
      required: '* Indique un champ obligatoire',
      email: "Courriel de l'Agent",
      agentFirstName: "Prénom de l'Agent",
      agentLastName: "Nom de l'Agent",
      company: "Nom de l'entreprise",
      iata: 'N° IATA/CLIA',
      stateProvince: 'État/Province',
      postalCode: 'Code Postal *',
      country: 'Pays',
      clientLastName: "Nom de l'Invité",
      confirmationNumber: "Numéro de Confirmation d'Hôtel",
      flightNumber: 'Numéro de Vol',
      hotelName: "Nom de l'Hôtel",
      bookingNumber: 'Numéro de Confirmation de Réservation',
      numberOfGuests: "Nombre d'Invités Adultes",
      bookingDate: 'Date de Réservation',
      tourOperator: 'Tour-opérateur / Méthode de Réservation',
      firstName: 'Prénom',
      lastName: "Nom de l'Invité",
      guestLastName: "Nom de l'Invité",
      accommodation: 'Station/Hôtel/Hébergements réservés',
      select: 'Sélectionner une option',
      wholesaler: "Nom du Grossiste (si applicable) : si c'est une réservation directe, entrez AUCUN",
      arrivalDate: "Date d'Arrivée",
      departureDate: 'Date de Départ',
      lengthOfStay: 'Durée du Séjour (en Nuits)',
      totalNights: 'Total de Nuits',
      reservationNumber: 'Numéro de Réservation',
      rooms: 'Nombre de Chambres',
      stay: 'Durée du Séjour (en Nuits)',
      airline: 'Compagnie Aérienne / Transporteur (code à 2 chiffres)',
      originAirport: "Passerelle d'Origine (code d'aéroport à 3 lettres)",
      destination: "Destination/île (code d'aéroport à 3 lettres)",
      cost: 'Coût Total de la Réservation (utiliser uniquement les décimales)',
      totalCost: 'Coût Total',
      file: 'Téléchargement de Preuve RezSnap™',
      disclaimer: '* Champs obligatoires',
      button: 'Soumettre votre réservation',
      sub: 'Vos informations',
      sub2: 'Informations de réservation',
      guests: 'Nombre de Passagers',
      numberOfPassengers: 'Nombre de Passagers',
      accommodationBooked: 'Station/Hôtel/Hébergements réservés',
      accommodationCharterCompany: 'Hôtel, villa, société de location',
      propertyCharterCompany: 'Propriété / Société de location',
      typeofBooking: 'Type de Réservation',
      dragAndDrop: 'Glissez et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers',
      acceptedFiles:
        'Seuls les fichiers .jpeg, .png et .pdf seront acceptés. La taille maximale du fichier est de 100 Mo.',
      missingRequiredFields: 'Veuillez remplir tous les champs obligatoires',
      invalidNumber: 'Doit être un nombre supérieur à 0.',
    },
    TermsAndConditions: {
      title: 'Termes et Conditions',
      button: 'Retour',
    },
    thankYouPage: {
      thanks: 'Merci',
      congrats: 'Félicitations, ',
      body: 'votre réservation a été reçue et envoyée au superviseur de campagne pour vérification.',
    },
    menu: {
      home: 'Centre des\nRécompenses',
      homeAmbassador: 'Aperçu',
      achievements: 'Réalisations\nde Formation',
      bookings: 'Tableau de Bord\ndes Réservations',
      form: 'Soumettre\ndes Réservations',
    },
  },
  badgeView: {
    title: 'Réalisations de formation',
    subtitle:
      'Suivez votre progression de formation, vos certifications et le statut de vos récompenses métalliques sur cette page. Vous pourrez également télécharger et partager votre diplôme {program_name_short}, ainsi que tous les badges que vous avez obtenus.',
    badgeDisplayTitle: 'Statut de réalisation métallique',
    badgeAchievement:
      "Vous avez atteint le statut {rank} ! Cliquez sur l'icône à droite pour visualiser et partager votre statut.",
    bronze: 'Bronze',
    silver: 'Argent',
    gold: 'Or',
    platinum: 'Platine',
    complete: 'TERMINÉ',
    diploma: 'Diplôme',
    chapterBadges: 'Badges de spécialisation',
    partnerBadges: 'Badges de partenaires',
    tierRewards: 'Récompenses de niveau',
    click: 'Cliquez ',
    here: 'ici',
    bronzeReward: ' pour accéder à votre récompense BRONZE exclusive.',
    silverReward: ' pour accéder à votre récompense ARGENT exclusive.',
    goldReward: ' pour accéder à votre récompense OR exclusive.',
    bronzeRewardTitle: 'Récompense Statut Bronze',
    silverRewardTitle: 'Récompense Statut Argent',
    goldRewardTitle: 'Récompense Statut Or',
  },
  badgeDisplay: {
    status: 'Statut de réalisation de formation',
  },
  tierCard: {
    achieved: 'Atteint',
    modules: 'modules',
    sales: 'Ventes',
    bookings: 'Réservations',
    or: 'ou',
    workingToward: 'En cours vers',
    currentTier: 'Niveau Actuel',
    workingTowardBronze: 'Complétez la certification pour atteindre le statut Bronze !',
    expiresIn: 'Expire dans',
    days: 'jours',
    expiringToday: "Expire aujourd'hui !",
    expiryDate: "Date d'Expiration",
    nextTier: 'Niveau Suivant',
    nextGoal: 'Prochain Objectif',
    allTiers: 'Tous les Niveaux',
    bronzeDescription: 'Récompense les conseillers qui complètent les bases et montrent un engagement initial.',
    silverDescription: 'Reconnaît les conseillers qui vendent régulièrement et restent engagés.',
    goldDescription: 'Récompense les meilleurs performeurs profondément investis dans la vente.',
    title: {
      bronze: 'Bronze',
      silver: 'Argent',
      gold: 'Or',
    },
    requirement: {
      bronze: 'Complétez la Certification Spécialiste des Bahamas',
      silver: 'Réalisez $5,000+ en ventes de voyages aux Bahamas ou 5+ réservations',
      gold: 'Réalisez $15,000+ en ventes de voyages aux Bahamas ou 15+ réservations',
    },
    tierCopy: 'Félicitations ! Vous avez atteint le statut {tier} !',
  },
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
  categories: {
    all: 'Tout',
    accommodations: {
      accommodations: 'Hébergements',
      bedbreakfast: 'Gîte du Passant',
      campgroundsrvparks: 'Terrains de Camping et Parcs de VR',
      condo: 'Condo',
      hotel: 'Hôtel',
      vacationrentals: 'Locations de Vacances',
    },
    attractions: 'Attractions',
    dining: 'Restauration',
  },
  preregisterView: {
    comingSoon: 'Bientôt disponible :',
    title: 'Le nouveau {appName}',
    success:
      'Vous avez été préinscrit(e) avec succès au programme. Vous recevrez un e-mail lors du lancement du programme.',
    fillRequired: 'Veuillez remplir tous les champs obligatoires : {fields}',
    email: 'E-mail',
    firstName: 'Prénom',
    lastName: 'Nom',
    agencyName: 'Nom de l’agence',
    country: 'Pays',
    selectDefault: 'Veuillez sélectionner une option ci-dessous',
    requiredFields: '* Champs obligatoires',
    submit: 'Envoyer',
    isRegistered:
      'Vous avez été préinscrit(e) avec succès au programme. Vous recevrez un e-mail lors du lancement du programme.',
    somethingWentWrong: "Une erreur s'est produite. Veuillez réessayer.",
  },
  profileImageView: {
    currentImage: 'Votre photo de profil actuelle:',
    uploadImage: 'Télécharger votre photo de profil :',
    chooseAFile: 'Choisissez un fichier…',
    cancel: 'Annuler',
    backButton: 'Retour',
    uploadButton: 'Télécharger une photo de profil',
    saveButton: 'Enregistrer cette image de profil',
    fileTooLargeTitle: 'La taille du fichier à télécharger est trop importante',
    fileTooLargeText: 'La taille maximale des images est de 10 Mo',
  },
  FastTrackView: {
    incorrectAnswer: "Ce n'est pas correct.",
    question: 'Q{current}/{total}',
    questionCounter: '{current} sur {total} questions',
    score: 'Score : {correct}/{total}',
    nextIn: 'Suivant dans {count}s',
    goToNextQuestion: 'Question suivante',
    gradeEarned: 'Note obtenue',
    correct: 'Correct',
    completeFastTrack: 'Terminer le Fast Track',
    beginFullTraining: 'Commencer la formation complète',
    fastTrackComplete: 'Fast Track terminé !',
    fastTrackNotPassed: 'Fast Track non réussi',
    downloadDiploma: 'Télécharger le diplôme',
    resultSuccessMessage: 'Félicitations — vous avez réussi le Fast Track et gagné votre diplôme !',
    resultAchievementsPrefix: ' Vous pouvez accéder à votre diplôme dans la section ',
    resultAchievementsLinkText: 'Réalisations de formation',
    resultAchievementsSuffix: '.',
    resultFailureMessage:
      "Malheureusement, vous n'avez pas réussi le Fast Track. Il est limité à une tentative par utilisateur — mais vous pouvez toujours obtenir votre diplôme ! Suivez la formation complète pour approfondir vos connaissances et terminez à votre propre rythme.",
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Conversations précédentes',
    showNextSuggestionsAria: 'Afficher les prochaines suggestions',
    headingAria: 'Ouvrir TA SmartAssist',
    headingResumeAria: 'Reprendre la conversation',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Conversations récentes',
    previousConversations: 'Conversations précédentes',
    noRecentConversations: 'Aucune conversation récente',
    deleteConversationAria: 'Supprimer la conversation',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Nouvelle conversation',
    sourcesFromApp: 'Sources',
    loadingConversation: 'Chargement de la conversation…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Réflexion en cours…',
    messageLimitReached: 'Limite de messages atteinte',
    messageRemaining: '{remaining} message restant',
    messagesRemaining: '{remaining} messages restants',
    quotaBarAria: '{remaining} sur {total} messages restants',
    resetsAt: 'Réinitialisation le {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'cette destination',
    appNotReady: 'Application non configurée.',
    signInRequired: 'Veuillez vous connecter pour continuer.',
    genericError: 'Une erreur est survenue. Veuillez réessayer.',
    requestFailed: 'Requête échouée. Veuillez réessayer.',
    sourceFallback: 'Source',
    fallbackSuggestions: {
      bestBeaches: 'Meilleures plages',
      familyActivities: 'Activités en famille',
      hiddenGems: 'Trésors cachés',
      roadTrips: 'Road trips',
      dining: 'Meilleurs restaurants',
      events: 'Événements à venir',
    },
    structured: {
      confidenceThreshold: 'Confiance',
      confidenceThresholdPercentAria: 'Confiance : {percent}%',
      recommendation: 'Recommandation',
      alignment: "Vérification d'alignement",
      tailor: 'Pour personnaliser',
      tips: "Conseils d'efficacité",
    },
  },
  imageGallery: {
    noticeTitle: "Avis d'utilisation des images",
    noticeText:
      'Toutes les images sont sous licence exclusive de {clientName} et ne peuvent pas être utilisées sans permission',
  },
};
